import { createEvent, createStore } from "effector";

import type { WorkflowManifest } from "../../types/workflow-schema";

export type ManifestCapabilities = {
  /**
   * Whether the ACTIVE workflow manifest's Moving flow contains the
   * "availability" (OSE self-scheduling) step. Only the `on-site-estimate`
   * Sanity variant carries it — for everyone else (the control bucket of the
   * on-site-ose experiment, or a Sanity outage falling back to a stripped
   * build-time cache) this is false, and the Moving contracts + branching
   * fall back to the old flow (quoteCreate + callRequest → confirmation)
   * instead of routing to a page whose content cannot render.
   */
  movingHasAvailabilityStep: boolean;
};

/**
 * Fired by useWorkflowManifest with whatever manifest the app is actually
 * routing with (live, coalesced-default, or build-time cache) — so the
 * branching decision and the router can never disagree about the step's
 * existence.
 */
export const activeManifestChanged = createEvent<WorkflowManifest>();

export const $manifestCapabilities = createStore<ManifestCapabilities>({
  movingHasAvailabilityStep: false,
}).on(activeManifestChanged, (_, manifest) => ({
  movingHasAvailabilityStep: !!manifest?.serviceCategories?.Moving?.some(
    (step) => step.stepId === "availability",
  ),
}));
